module.exports = __webpack_public_path__ + "static/turtle-creek-house33-667966667cd318086c082473ef022c42.jpg";